import { AdaptedRefinements } from "components/RefinementField/types";
export const getCriteriaKeys = <T extends string>(
  adaptedRefinements: AdaptedRefinements<T>
) => {
  return Object.keys(adaptedRefinements) as T[];
};
